import { IMilestoneTemplate } from "@/interfaces";
import _ from "lodash";
import { IntlShape } from "react-intl";
import { toast } from "react-toastify";
import { findTargetGeneration } from "./findTargetGeneration";
import { findTargetParentMilestoneRecursive } from "./findTargetParentMilestoneRecursive";

export const addChildMilestone = (
  milestones: IMilestoneTemplate[],
  target: IMilestoneTemplate,
  searchResultMilestone: IMilestoneTemplate,
  intl: IntlShape
) => {
  const parentMilestone = findTargetParentMilestoneRecursive(
    milestones,
    target
  );
  const parentGeneration = findTargetGeneration(milestones, target);

  if (parentMilestone) {
    const newChildMilestone = _.cloneDeep(searchResultMilestone);

    newChildMilestone.areProjectSkusRequired = false;
    newChildMilestone.shouldCompleteProject = false;
    newChildMilestone.secureProjectOnCompletion = false;
    newChildMilestone.targetDatesRequired = false;
    if (
      !IsValidChildMilestoneDepth(searchResultMilestone, parentGeneration ?? 1)
    ) {
      newChildMilestone.childMilestones = [];
      toast.error(
        intl.formatMessage({
          id: "milestoneTemplates.copyChildrenMilestoneError",
        })
      );
    }

    parentMilestone.childMilestones = [
      ...(parentMilestone.childMilestones || []),
      newChildMilestone,
    ];
  }
};

const IsValidChildMilestoneDepth = (
  milestone: IMilestoneTemplate,
  currentGeneration: number
) => recursivlyCheckChildMilestones(milestone, currentGeneration) <= 3;

const recursivlyCheckChildMilestones = (
  milestone: IMilestoneTemplate,
  generation: number
) => {
  let maxGeneration = generation;

  if (milestone.childMilestones && milestone.childMilestones.length > 0) {
    milestone.childMilestones.forEach((child) => {
      const childGeneration = recursivlyCheckChildMilestones(
        child,
        generation + 1
      );

      maxGeneration = Math.max(maxGeneration, childGeneration);
    });
  }

  return maxGeneration;
};
